




















































import { Component, Mixins } from "vue-property-decorator";
import Company, { AgentsCompanyMixinTags } from "@/mixins/http/Agents/Company";
import { AdcontrolProfile, User } from "@/models";
import { Getter, Action } from "vuex-class";
import MatchPrincipalAccordion from "@/components/Agents/MatchPrincipalAccordion.vue";
import { AgentModuleConfiguration } from "@/models";
import AgentModuleConfigurationMixin, {
  AgentModuleConfigurationMixinTags,
} from "@/mixins/http/Agencies/AgentModuleConfigurationMixin";
import ClientCompany from "@/models/Agents/Company";
import ToastInvoker from "@/utils/ToastInvoker";
import NotificationBadge, {
  NotificationBadgeGroups,
} from "@/components/Agents/NotificationBadge.vue";
import { RequestData } from "@/store/types/RequestStore";

@Component({
  components: {
    NotificationBadge,
    MatchPrincipalAccordion,
  },
})
export default class PrincipalsCompanyManagement extends Mixins(
  Company,
  AgentModuleConfigurationMixin
) {
  @Getter("profile") readonly profile!: AdcontrolProfile;
  @Getter("user") readonly user!: User;
  @Getter("http/status") readonly httpStatus!: { [key: string]: RequestData };

  @Action("notificationsGroups/valorizeCompany")
  readonly valorizeCompanyNotifications!: (notificationCount: number) => void;

  missingPrincipals: string[] = [];
  agentModuleConfiguration: AgentModuleConfiguration | null = null;
  notificationBadgeGroups: NotificationBadgeGroups[] = [
    NotificationBadgeGroups.Company,
  ];
  async mounted() {
    await this.valorizeCompanies();
    await this.valorizeAgentModuleConfiguration();
  }

  get loading(): boolean {
    const companiesLoading =
      this.httpStatus[AgentsCompanyMixinTags.GetCompanies]?.loading ?? false;

    const agentModuleConfigurationLoading =
      this.httpStatus[
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration
      ]?.loading ?? false;

    return companiesLoading || agentModuleConfigurationLoading;
  }

  async valorizeCompanies() {
    this.missingPrincipals = [];
    try {
      await this.getCompanies(
        AgentsCompanyMixinTags.GetCompanies,
        this.profile.slug,
        {
          "filter[with_no_principal]": 1,
          "page[size]": "all",
        }
      ).then((companies) => {
        this.missingPrincipals = [
          ...new Set(companies.map((company: ClientCompany) => company.name)),
        ];
      });

      this.valorizeCompanyNotifications(this.missingPrincipals.length);
    } catch (error) {
      ToastInvoker.errorToast("Errore nel caricamento", error);
    }
  }

  async valorizeAgentModuleConfiguration() {
    try {
      this.agentModuleConfiguration = await this.getAgentModuleConfiguration(
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration,
        this.profile.slug
      );
    } catch (_e) {
      this.agentModuleConfiguration = null;
    }
  }
}
